import styled from 'styled-components';
import { spacing } from 'ui/theme';
import { InputField } from 'lib/iterable-hook-form';
import { pxToRem } from 'utils/convert';

export const InlineFlex = styled.div`
  align-items: center;
  display: inline-flex;
  gap: ${spacing.base};
`;

export const InputFieldFixedWidth = styled(InputField)`
  width: ${pxToRem(80)};
  & input {
    width: 100%;
  }
`;
